module.exports = __webpack_public_path__ + "static/media/dietary-restriction.45af4fc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dietary-restriction.jpg
// module id = 254
// module chunks = 0